import React, { useContext, useEffect, useState } from "react";
import { getData, insertDataJson } from "../Tools/helpers";
import { useParams } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { AppContext } from "../contextApp";

import TextField from "@mui/material/TextField";

import PaymentCashModule from "./components/PaymentCashModule";
import PDFReceipt from "../Tools/PDFReceipt";
import PaymentOnline from "./components/PaymentOnline";
import { PageTitle } from "../components/PageHeader";

const PaymentDetail = () => {
  const { studentData, setStudentData } = useContext(AppContext);
  const [userData] = useState(JSON.parse(localStorage.getItem("USER_IUMV")));
  const [data, setData] = useState([]);
  const [listYear, setListYear] = useState([]);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [infoPayment, setInfoPayment] = useState({
    description: "",
    year: 0,
    amount: "",
    status: 0,
    status_description: 'Aprobado',
    evidence: "",
    surcharge: "",
    type: "",
    method_payment: "Transferencia",
    info_bill: {},
    register_date: "",
    folio_transfer: "",
    transfer_date: "",
    discount: "",
    month_id: "",
    student_id: "",
    email_student: "",
  });

  const { id } = useParams();
  const getStudent = async () => {
    const route = "Student";
    const send = await getData(`${route}/${id}`);
    console.log(send)
    if (send.code === 200) {
      setStudentData(send.data);
    }
  };

  const getPaymentFourMonth = async (year) => {
    const params = {
      year: (year).toString(),
      student_id: id,
    };
    const route = "PaymentFourMonth";
    const send = await insertDataJson(`${route}/${id}`, params);
    if (send.code === 200) {
      setData(send.data);
    }
  };

  const getInfoPayment = (item, fourMountn) => {
    setInfoPayment({
      ...infoPayment,
      payment_four_month_id: item.payment_four_month_id,
      amount: item.monthly_payment,
      surcharge: item.surcharge_payment,
      description: item.type === 'inscription' ? "REINSCRIPCION" : "COLEGIATURA",
      month: item.description,
      four_month: fourMountn,
      month_id: item.id,
      student_id: id,
      method_payment:
        item.paid_status === "paid" || item.paid_status === "surchargePaid"
          ? item.method_payment
          : userData.abbreviation === "student"
          ? "Transferencia"
          : "Efectivo",
      type: item.type,
      info_bill: item.info_bill,
      code: item.code,
      folio_transfer: item.folio_transfer,
      transfer_date: item.transfer_date,
      evidence: item.evidence ? item.evidence : "",
      paid_status: item.paid_status,
      discount: 0,
      email_student: studentData.email,
      you_can_pay: item.you_can_pay,
      status: item.status,
      payday_limit: item.payday_limit,
      numberOfDays: item.numberOfDays
    });
  };

  const toListYear = () => {
    const year = new Date().getFullYear();
    setInfoPayment({
      ...infoPayment,
      year: year,
    });
    let years = [];
    for (let i = year - 5; i <= year + 2; i++) {
      years.push(i);
    }
    setListYear(years);
  };

  const changeYear = (e) => {
    setYearSelected(e.target.value);
    setInfoPayment({
      ...infoPayment,
      year: e.target.value,
    });
    getPaymentFourMonth(e.target.value);
  };

  useEffect(() => {
    getStudent();
    toListYear();
    const year = new Date().getFullYear();
    setYearSelected(year);
    getPaymentFourMonth(year);
  }, []);

  const ListMonthPayment = ({ item, month, statusPayment, fourMountn, statusDescription, colorDescription, isSelected }) => {
    let labelStatus =
      statusPayment === "paid"
        ? "Pagado"
        : statusPayment === "surcharge"
        ? "Recargo"
        : statusPayment === "surchargePaid"
        ? "Pagado Recargo"
        : "Programado";

    let iconStatus =
      statusPayment === "paid"
        ? parseInt(item.status) === 1 ? "fa-square-check text-orange-500 " : "fa-square-check text-green-500 "
        : statusPayment === "surcharge"
        ? "fa-square-xmark text-red-500"
        : statusPayment === "surchargePaid"
        ? parseInt(item.status) === 1 ? "fa-square-check text-orange-500 " : "fa-square-check text-green-500 "
        : "fa-square-xmark text-slate-300";
    iconStatus = "fa-solid text-xl " + iconStatus;

    let iconDocumentStatus =
      statusPayment === "paid" && parseInt(item.status) === 0
        ? "fa-file text-slate-700 block cursor-pointer"
        : statusPayment === "surchargePaid"
        ? "fa-coins text-slate-700 block cursor-pointer"
        : "fa-square text-slate-100";
    iconDocumentStatus = "fa-solid text-xl " + iconDocumentStatus;

    if(parseInt(item.status) === 2 &&  item.method_payment === 'Transferencia') {
      labelStatus = "Reenviar";
    }

    if(parseInt(item.status) === 2 &&  item.method_payment === 'En linea') {
      labelStatus = "No se acreditó";
    }

    if(parseInt(item.status) === 2) {
      iconStatus = "fa-solid text-xl fa-square-check text-red-500";
    }

    const isPaid = statusPayment === "paid" || statusPayment === "surchargePaid";
    const isSurcharge = statusPayment === "surcharge";
    const isDeclined = parseInt(item.status) === 2;
    const isPending = parseInt(item.status) === 1;

    const borderColor = isDeclined
      ? '#ef4444'
      : isPending
      ? '#f59e0b'
      : isPaid
      ? '#22c55e'
      : isSurcharge
      ? '#ef4444'
      : '#e2e8f0';

    const badgeBg = statusDescription === 'Aprobado'
      ? { bg: '#dcfce7', color: '#166534' }
      : { bg: '#fef9c3', color: '#854d0e' };

    return (
      <div
        className={isSelected ? '' : 'bg-slate-50 hover:bg-slate-100'}
        onClick={() => getInfoPayment(item, fourMountn)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '9px 12px', marginBottom: '4px', borderRadius: '7px',
          border: isSelected ? '1px solid #111827' : '1px solid #f1f5f9',
          borderLeft: `3px solid ${isSelected ? '#dc2626' : borderColor}`,
          ...(isSelected ? { backgroundColor: '#111827' } : {}),
          transition: 'background-color 0.12s, border-color 0.12s',
          boxShadow: isSelected ? '0 1px 4px rgba(0,0,0,0.15)' : 'none',
          cursor: 'pointer',
        }}
      >
        {/* Month name */}
        <label
          style={{ cursor: 'pointer', fontSize: '0.82rem', fontWeight: isSelected ? 700 : 500, color: isSelected ? '#f9fafb' : '#374151', flex: 1, pointerEvents: 'none' }}
        >
          {item.type === 'inscription'
            ? <><span style={{ fontWeight: 700, color: isSelected ? '#fff' : '#111827' }}>{month}</span> <span style={{ fontSize: '0.7rem', backgroundColor: isSelected ? 'rgba(255,255,255,0.15)' : '#e0e7ff', color: isSelected ? '#c7d2fe' : '#4338ca', padding: '1px 6px', borderRadius: '4px', fontWeight: 600 }}>Reinscripción</span></>
            : month}
        </label>

        {/* Right side: status icon + PDF + badge */}
        <div onClick={e => e.stopPropagation()} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className={iconStatus} style={{ fontSize: '16px' }}></i>

          <label style={{ lineHeight: 0 }}>
            {(statusPayment === "paid" || statusPayment === "surchargePaid") && item.status !== 1 ? (
              <PDFDownloadLink
                document={
                  <PDFReceipt
                    name={studentData.name ? studentData.name : ""}
                    curp={studentData.curp ? studentData.curp : ""}
                    career={studentData.career_name ? studentData.career_name : ""}
                    item={item}
                    description={`${item.description_payment} ${item.description} ${yearSelected}`}
                  />
                }
                fileName={`Recibo_${item.description}_${yearSelected}`}
              >
                <i className={iconDocumentStatus} style={{ fontSize: '16px' }}></i>
              </PDFDownloadLink>
            ) : (
              <i className={iconDocumentStatus} style={{ fontSize: '16px' }}></i>
            )}
          </label>

          {statusDescription && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ fontSize: '0.72rem', color: '#9ca3af' }}>{labelStatus}</span>
              <span style={{
                fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px', borderRadius: '9999px',
                backgroundColor: badgeBg.bg, color: badgeBg.color,
              }}>
                {statusDescription}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1">

      {/* Student header + year selector */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '8px' }}>
        <div>
          {studentData.name && <PageTitle>{studentData.name}</PageTitle>}
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '4px' }}>
            {studentData.curp && (
              <span style={{ fontSize: '0.72rem', color: '#6b7280', fontFamily: 'monospace' }}>{studentData.curp}</span>
            )}
            {studentData.career_name && (
              <span style={{ fontSize: '0.72rem', backgroundColor: '#f1f5f9', color: '#374151', padding: '2px 8px', borderRadius: '4px' }}>{studentData.career_name}</span>
            )}
            {studentData.university_name && (
              <span style={{ fontSize: '0.72rem', backgroundColor: '#f1f5f9', color: '#374151', padding: '2px 8px', borderRadius: '4px' }}>{studentData.university_name}</span>
            )}
          </div>
        </div>
        <div style={{ paddingTop: '28px' }}>
          <TextField
            sx={{ m: 0 }}
            id="years"
            name="years"
            label="Año"
            value={infoPayment.year}
            size="small"
            select
            SelectProps={{ native: true }}
            onChange={(e) => changeYear(e)}
          >
            <option value="0">Seleccione una opción</option>
            {listYear.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </TextField>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: '24px' }}>

        {/* Left: steps + month list */}
        <div>
          {/* Steps */}
          <div style={{
            display: 'flex', gap: '8px', marginBottom: '20px',
            padding: '12px 14px', backgroundColor: '#f8fafc',
            borderRadius: '8px', border: '1px solid #e2e8f0',
          }}>
            {["Selecciona el mes", "Verifica el monto", "Elige el método de pago"].map((step, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
                <span style={{
                  width: '20px', height: '20px', borderRadius: '50%',
                  backgroundColor: '#111827', color: '#fff',
                  fontSize: '0.65rem', fontWeight: 700,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>{i + 1}</span>
                <span style={{ fontSize: '0.72rem', color: '#374151', fontWeight: 500 }}>{step}</span>
                {i < 2 && <span style={{ color: '#d1d5db', fontSize: '10px', marginLeft: 'auto' }}>›</span>}
              </div>
            ))}
          </div>

          {/* Section heading */}
          <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px', marginBottom: '12px' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Cuatrimestres</span>
          </div>

          {/* Month list */}
          <div>
            {data.map((month) => (
              month.inscription ? (
                <div key={month.id + month.inscription.type + month.num_month} style={{ marginBottom: '8px', padding: '8px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                  <div style={{ fontSize: '0.65rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px', paddingLeft: '4px' }}>
                    {month.description}
                  </div>
                  <ListMonthPayment
                    item={month.inscription}
                    fourMountn={month.description}
                    month={month.inscription.description}
                    statusPayment={month.inscription.paid_status}
                    statusDescription={month.inscription.status_description}
                    colorDescription={month.inscription.status_description === 'Aprobado' ? 'bg-green-500' : 'bg-yellow-500'}
                    isSelected={infoPayment.month_id === month.inscription.id && infoPayment.type === 'inscription'}
                  />
                  <ListMonthPayment
                    item={month}
                    fourMountn={month.description}
                    month={month.description}
                    statusPayment={month.paid_status}
                    statusDescription={month.status_description}
                    colorDescription={month.status_description === 'Aprobado' ? 'bg-green-500' : 'bg-yellow-500'}
                    isSelected={infoPayment.month_id === month.id && infoPayment.type !== 'inscription'}
                  />
                </div>
              ) : (
                <ListMonthPayment
                  item={month}
                  fourMountn={month.description}
                  key={month.id}
                  month={month.description}
                  statusPayment={month.paid_status}
                  statusDescription={month.status_description}
                  colorDescription={month.status_description === 'Aprobado' ? 'bg-green-500' : 'bg-yellow-500'}
                  isSelected={infoPayment.month_id === month.id}
                />
              )
            ))}
          </div>
        </div>

        <PaymentCashModule
          infoPayment={infoPayment}
          setInfoPayment={setInfoPayment}
          refreshList={getPaymentFourMonth}
          studentData={studentData}
        />
      </div>
    </div>
  );
};

export default PaymentDetail;
